import { Box, Heading, Stack, Text, ThemeContext } from '@vouched.id/vault';
import React, { useContext, useState } from 'react';
import { AmlFieldLabel } from 'components/account/jobs-v2/dropdowns/AML/AmlFieldLabel';
import { AmlV2Listing } from 'components/account/jobs-v2/dropdowns/AML/AmlV2Listing';
import { AML_BORDER_COLOR } from 'components/account/jobs-v2/dropdowns/AML/amlV2Utils';
const COLLAPSED_VALUE_COUNT = 3;
const MetaChip = ({ label, values }) => {
    const { tokens } = useContext(ThemeContext).theme;
    const [isExpanded, setIsExpanded] = useState(false);
    const uniqueValues = [...new Set(values)];
    const isEmpty = uniqueValues.length === 0;
    const hiddenCount = uniqueValues.length - COLLAPSED_VALUE_COUNT;
    const visibleValues = isExpanded
        ? uniqueValues
        : uniqueValues.slice(0, COLLAPSED_VALUE_COUNT);
    return (React.createElement(Box, { alignItems: "baseline", display: "inline-flex", maxWidth: "100%", paddingX: "spacing.small", paddingY: "spacing.xsmall2", style: {
            gap: tokens.spacing.xsmall,
            border: `1px ${isEmpty ? 'dashed' : 'solid'} ${AML_BORDER_COLOR}`,
            borderRadius: tokens.radii.medium,
            backgroundColor: tokens.colors.gray50
        } },
        React.createElement(Text, { style: {
                flexShrink: 0,
                fontSize: tokens.text.size.xsmall,
                fontWeight: tokens.text.weight.bold,
                letterSpacing: '0.03em',
                color: isEmpty ? tokens.colors.gray600 : tokens.colors.gray300
            }, tag: "span" }, label),
        React.createElement(Text, { "data-ph-mask": true, style: {
                fontSize: tokens.text.size.small,
                fontWeight: tokens.text.weight.semiBold,
                overflowWrap: 'anywhere',
                ...(isEmpty && { fontStyle: 'italic', color: tokens.colors.gray600 })
            }, tag: "span" },
            isEmpty ? 'Not provided' : visibleValues.join(', '),
            hiddenCount > 0 && (React.createElement("button", { "aria-expanded": isExpanded, "aria-label": `${isExpanded ? 'Show less' : `+${hiddenCount} more`} ${label}`, onClick: () => {
                    setIsExpanded(!isExpanded);
                }, style: {
                    marginLeft: tokens.spacing.xsmall,
                    padding: 0,
                    border: 'none',
                    background: 'none',
                    cursor: 'pointer',
                    font: 'inherit',
                    color: tokens.colors.purple,
                    whiteSpace: 'nowrap'
                }, type: "button" }, isExpanded ? 'Show less' : `+${hiddenCount} more`)))));
};
export const AmlV2MatchCard = ({ risk }) => {
    const { tokens } = useContext(ThemeContext).theme;
    return (React.createElement(Box, { style: {
            border: `1px solid ${AML_BORDER_COLOR}`,
            borderRadius: tokens.radii.xlarge,
            overflow: 'hidden'
        } },
        React.createElement(Stack, { backgroundColor: "colors.gray50", paddingX: "spacing.large", paddingY: "spacing.default", spacing: "spacing.xsmall", style: { borderBottom: `1px solid ${AML_BORDER_COLOR}` } },
            'changeType' in risk && (React.createElement(AmlFieldLabel, { tag: "p" }, `${risk.changeType} · ${new Date(risk.receivedAt).toLocaleString()}`)),
            React.createElement(Heading, { "data-ph-mask": true, style: { margin: 0, fontWeight: tokens.text.weight.extraBold }, tag: "h5" }, risk.matchingName ?? 'Matching Profile'),
            React.createElement(Box, { display: "flex", flexWrap: "wrap", style: { gap: tokens.spacing.xsmall } },
                risk.matchingName && (React.createElement(MetaChip, { label: "DOB", values: risk.datesOfBirth })),
                React.createElement(MetaChip, { label: "AKA", values: risk.akas }))),
        React.createElement(Box, { display: "flex", flexDirection: "column", padding: "spacing.large", style: { gap: tokens.spacing.small } }, risk.listings.map((listing, index) => (React.createElement(AmlV2Listing, { key: index, listing: listing }))))));
};
